import { IconProps } from './IconProps';

export const LocationArrow = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.79805 8.09063C2.03233 8.32491 2.26662 8.39863 2.7289 8.39863L7.79805 8.42549C7.8449 8.42549 7.8849 8.42549 7.90519 8.45206C7.92519 8.47206 7.93176 8.51234 7.93176 8.55263L7.95176 13.6286C7.95862 14.0906 8.03233 14.3249 8.26662 14.5592C8.58147 14.8806 9.02347 14.8272 9.35147 14.5058C9.52576 14.3315 9.66633 14.0438 9.79347 13.7758L14.9163 2.72691C15.184 2.16463 15.1506 1.7492 14.8763 1.47463C14.608 1.20691 14.1929 1.17349 13.6306 1.4412L2.58147 6.56406C2.31347 6.6912 2.02576 6.83177 1.85147 7.00606C1.53005 7.33406 1.47662 7.76949 1.79805 8.09091"
        fill={props.fill ?? '#000000'}
      />
    </svg>
  );
};

